import { CSSProperties } from "react";
import {
  FeatureItemTypes,
  ServiceDetailFeatureSectionType,
} from "../../../utility/types/generaTypes";
import "./ServiceDetailFeatureSection.css";
type ServiceDetailFeatureSectionProps = {
  style?: CSSProperties;
  featureSection: ServiceDetailFeatureSectionType;
};
const ServiceDetailFeatureSection = ({
  style,
  featureSection,
}: ServiceDetailFeatureSectionProps) => {
  return (
    <section style={style}>
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{featureSection.title}</h1>
          <p className="section_description">{featureSection.description}</p>
        </div>
        <div className="featureCards_container">
          {featureSection.data.map((feature, index) => (
            <FeatureCard key={"FeatureCard" + index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

type TechnologyWeUseCardProps = {
  feature: FeatureItemTypes;
};

const FeatureCard = ({ feature }: TechnologyWeUseCardProps) => {
  return (
    <div className="featureCard_container">
      <img src={feature.icon} alt={feature.title} />
      <h2>{feature.title}</h2>
    </div>
  );
};

export default ServiceDetailFeatureSection;
